<ng-container *ngIf="model">
  <!-- Medium and large devices layout -->
  <div class="row no-gutters my-4 hidden-xs hidden-sm mb-product-line"
       data-cy="mb-product-line">
    <div class="badges-wrapper" data-cy="mb-product-line-stamps">
      <ng-container *ngFor="let stamp of stamps">
          <span class="badge rounded-pill mr-3"
                [ngClass]="{ 'badge-danger': constants?.FINAL_STOCK_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()),
                'badge-success': constants?.HIGHLIGHT_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()),
                 'badge-warning': constants?.NEW_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()) }">
            <span *ngIf="constants?.FINAL_STOCK_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
            <span *ngIf="constants?.HIGHLIGHT_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
            <span *ngIf="constants?.NEW_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
          </span>
      </ng-container>
    </div>
    <div class="my-auto pl-3 hidden-md mb-product-line-code-wrapper"
         [ngClass]="model?.productLine?.length > 1 ? 'mb-one-and-half-column-width' : 'col-2'"
         data-cy="mb-product-line-code" [mbCopyToClipboard]="model.code" mbShowPopup>
      <mb-clipboard-popup role="tooltip" data-cy="mb-show-clipboard-popup"></mb-clipboard-popup>
      <div class="cursor-pointer mb-1 copy-to-clipboard" title="Copy to clipboard">
        <img src="assets/icons/svg/copy.svg"
             class="pr-2"
             alt="Copy to clipboard icon"
             title="Copy to clipboard"
             aria-label="Copy product code"
             data-cy="mbProductLineCodeIcon"/>
        <span class="mb-product-line-code"><strong [innerHTML]="model.code | safeHtml"></strong></span>
      </div>
      <p *ngIf="model.regulatoryStatus" class="mb-product-line-rstatus"
         data-cy="mb-product-line-rstatus"
         [innerHTML]="model.regulatoryStatus | safeHtml">
      </p>

    </div>

    <div [ngClass]="showDynamicColumns? 'col-md-3' : 'col-md-5 col-lg-3'" class="my-auto pl-md-2 pl-lg-3 position-static"
         data-cy="mb-product-line-name">
      <!-- Only show this on medium size devices -->
      <div class="d-sm-none d-md-block d-lg-none cursor-pointer mb-1 mb-product-line-code-wrapper"
           [mbCopyToClipboard]="model.code" mbShowPopup>
        <mb-clipboard-popup role="tooltip" data-cy="mb-show-clipboard-popup"></mb-clipboard-popup>
        <img src="assets/icons/svg/copy.svg"
             class="pr-2"
             alt="Copy to clipboard icon"
             title="Copy to clipboard"
             aria-label="Copy product code"
             data-cy="mbProductLineCodeIcon"/>
        <span class="mb-product-line-code" title="Copy to clipboard"><strong [innerHTML]="model.code | safeHtml"></strong></span>
      </div>
      <p *ngIf="model.regulatoryStatus" class="d-sm-none d-md-block d-lg-none mb-product-line-rstatus"
         data-cy="mb-product-line-rstatus"
         [innerHTML]="model.regulatoryStatus | safeHtml">
      </p>
      <!-- End only show this on medium size devices -->

      <div class="pt-2" data-cy="mb-product-line-name">
        <strong [innerHTML]="model.name | safeHtml" data-analytics="product-title"></strong>
        <span *ngIf="model.clinicalReferenceNumber"
              class="ml-1"
              [innerHTML]="'(' + model.clinicalReferenceNumber + ')' | safeHtml"></span>
      </div>
      <div *ngIf="model.components?.length > 0"
           class="d-inline-block mr-3 mb-product-components"
           (click)="open(model.components)"
           data-cy="mb-product-line-components">
        <a class="mb-product-line-data-sheet">
          {{'pdpProductLine.viewComponents' | mbTranslate}}
        </a>
      </div>
      <div class="d-inline-block">
        <div *ngIf="model.dataSheets?.entry"
             data-cy="mb-product-line-mb-data-sheets">
        <span class="mb-product-line-data-sheet">
           <span *ngIf="model.dataSheets?.entry.length > 1; else oneDataSheet"
                 (click)="openMultiValueModal(model.dataSheets, 'datasheets')">
             {{'mbcommon.dataSheets' | mbTranslate}}
           </span>
            <ng-template #oneDataSheet>
              <div *ngFor="let dataSheet of model.dataSheets.entry">
                <span class="mb-product-line-data-sheet"
                      data-cy="mb-product-line-data-sheet"
                      [innerHTML]="addDataSheetUserManualLink(dataSheet.value, 'mbcommon.dataSheet', false) | async  | safeHtml"
                      data-tagname="Data sheets"
                      mbCmsInnerHTML
                ></span>
              </div>
            </ng-template>
         </span>
        </div>
      </div>
      <div *ngIf="model.userManuals?.entry"
           class="d-inline-block"
           data-cy="mb-product-line-mb-user-manuals">
        <span class="mb-product-line-data-sheet">
           <span *ngIf="model.userManuals?.entry.length > 1; else oneUserManual"
                 (click)="openMultiValueModal(model.userManuals, 'usermanuals')">
             {{'pdpProductLine.userManuals' | mbTranslate}}
           </span>
            <ng-template #oneUserManual>
              <div *ngFor="let userManual of model.userManuals.entry">
                <span class="mb-product-line-data-sheet"
                      [innerHTML]="addDataSheetUserManualLink(userManual.value, 'pdpProductLine.userManual', false) | async | safeHtml"
                      data-cy="mb-product-line-user-manual"
                      data-tagname="User manuals"
                      mbCmsInnerHTML
                ></span>
              </div>
            </ng-template>
        </span>
      </div>
    </div>

    <ng-container *ngIf="showDynamicColumns; else noDynamicColumns">
      <div *ngIf="!model.productLine"
           class="col my-auto pl-3 mb-product-line-values product-line-dynamic-column">
      </div>
      <div *ngFor="let dynamicColumn of model.productLine"
           class="col my-auto pl-3 mb-product-line-values product-line-dynamic-column"
           data-cy="mb-product-line-applications">
        <span [innerHTML]="dynamicColumn?.value | safeHtml"></span>
      </div>
    </ng-container>

    <ng-template #noDynamicColumns>
      <div class="mb-no-dynamic-col-width my-auto pl-3 mb-product-line-values product-line-dynamic-column"></div>
    </ng-template>

    <div [ngClass]="[showDynamicColumns ? 'mb-product-quantity-column-width pl-3' : isWishListShown ? 'col-2 pl-4' : 'mb-two-and-half-column-width pl-md-0 pl-lg-4', 'my-auto qty-selector']"
         data-cy="mb-product-line-quantity">
      <mb-quantity-counter
        [control]="addToCartForm.get('quantity')"
        [max]="maxItemQuantity"
        [min]="1">
      </mb-quantity-counter>
    </div>

    <div [ngClass]="[showDynamicColumns ? 'mb-one-and-half-column-width pl-3' : isWishListShown ? 'col-2 pl-4' : 'mb-two-and-half-column-width pl-md-3 pl-lg-4', 'my-auto text-left']"
         data-cy="mb-product-line-price">
      <span>
        <span *ngIf="!hasPriceOnRequest(); else onRequest">
          <strong [innerHTML]="model.priceData?.formattedValue | safeHtml"></strong>
        </span>
        <ng-template #onRequest>
          <strong>{{'mbcommon.onRequest' | mbTranslate}}</strong>
        </ng-template>
      </span>
    </div>

    <div [ngClass]="[showDynamicColumns ? 'mb-add-to-cart-button-column-width pl-3 pr-3' : !isWishListShown ? 'col pl-3 pr-2 pl-md-3 pl-lg-4 pr-lg-3 pl-xl-4' : 'mb-add-to-cart-no-dynamic-wishlist-column-width pl-3 pr-2', 'my-auto mb-flex-end']"
         data-cy="mb-product-line-actions">
      <mb-add-to-cart [addToCartForm]="addToCartForm"
                      [clickSource]="dataAnalyticsClickSource"
                      [hasPriceOnRequest]="hasPriceOnRequest()"
                      [product]="model"
                      [productCode]="model.code">
      </mb-add-to-cart>
    </div>

    <div *ngIf="isWishListShown" [ngClass]="[!showDynamicColumns ? 'pr-2' : 'pr-3', 'mb-half-column-width my-auto']">
      <mb-product-line-wishlist [product]="model"></mb-product-line-wishlist>
    </div>
  </div>


  <!-- Small devices layout -->
  <div class="row no-gutters my-4 mb-product-line hidden-md hidden-lg hidden-xl"
       data-cy="mb-product-line-sm">
    <div class="col-12 my-auto position-static">
      <div class="row no-gutters my-1 pb-3"
           data-cy="mb-product-line-code-sm">
        <div class="col-5 position-static">
          <div class="cursor-pointer mb-1 mb-product-line-code-wrapper" [mbCopyToClipboard]="model.code" mbShowPopup>
            <mb-clipboard-popup role="tooltip" data-cy="mb-show-clipboard-popup-sm"></mb-clipboard-popup>
            <div class="badges-wrapper" data-cy="mb-product-line-stamps">
              <ng-container *ngFor="let stamp of stamps">
                <span class="badge rounded-pill mr-3"
                      [ngClass]="{ 'badge-danger': constants?.FINAL_STOCK_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()),
                      'badge-success': constants?.HIGHLIGHT_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()),
                      'badge-warning': constants?.NEW_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase()) }">
                  <span *ngIf="constants?.FINAL_STOCK_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
                  <span *ngIf="constants?.HIGHLIGHT_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
                  <span *ngIf="constants?.NEW_LABEL?.toLowerCase()?.includes(stamp?.toLowerCase())">{{stamp.toUpperCase()}}</span>
                </span>
              </ng-container>
            </div>
            <img src="assets/icons/svg/copy.svg"
                 class="pr-2"
                 alt="Copy to clipboard icon"
                 title="Copy to clipboard"
                 aria-label="Copy product code"
                 data-cy="mb-product-line-code-icon-sm"/>
            <span class="mb-product-line-code" title="Copy to clipboard"><strong [innerHTML]="model.code | safeHtml"></strong></span>
          </div>
          <p *ngIf="model.regulatoryStatus" class="mb-product-line-rstatus"
             data-cy="mb-product-line-rstatus-sm"
             [innerHTML]="model.regulatoryStatus | safeHtml">
          </p>
        </div>

        <div class="col-6 pl-3"
             data-cy="mb-product-line-name-sm">
          <div><strong [innerHTML]="model.name | safeHtml"></strong> <span *ngIf="model.clinicalReferenceNumber" class="ml-1"
                                                                           [innerHTML]="'(' + model.clinicalReferenceNumber + ')' | safeHtml"></span>
          </div>
          <div *ngIf="model.components?.length > 0" class="mt-3 mb-product-components" (click)="open(model.components)"
               data-cy="mb-product-line-sm-components">
            <a class="mb-product-line-data-sheet">
              {{'pdpProductLine.viewComponents' | mbTranslate}}
            </a>
          </div>
          <div class="mt-3">
            <div class="d-inline-block">
              <div *ngIf="model.dataSheets?.entry"
                   class="d-inline-block"
                   data-cy="mb-product-line-mb-data-sheets">
                  <span class="mb-product-line-data-sheet">
                     <span *ngIf="model.dataSheets?.entry.length  > 1; else oneDataSheet"
                           (click)="openMultiValueModal(model.dataSheets, 'datasheets')">
                       {{'mbcommon.dataSheets' | mbTranslate}}
                     </span>
                       <ng-template #oneDataSheet>
                        <div *ngFor="let dataSheet of model.dataSheets.entry">
                           <div class="mb-product-line-data-sheet"
                                data-cy="mb-product-line-data-sheet-sm"
                                [innerHTML]="addDataSheetUserManualLink(dataSheet.value, 'mbcommon.dataSheet', false) | async  | safeHtml"
                                data-tagname="Data sheets"
                                mbCmsInnerHTML
                           ></div>
                        </div>
                      </ng-template>
                  </span>
              </div>
            </div>
            <div *ngIf="model.userManuals?.entry"
                 data-cy="mb-product-line-mb-user-manuals-sm">
                  <span class="mb-product-line-data-sheet">
                     <span *ngIf="model.userManuals?.entry.length > 1; else oneUserManual"
                           (click)="openMultiValueModal(model.userManuals, 'usermanuals')">
                           {{'pdpProductLine.userManuals' | mbTranslate}}
                     </span>
                      <ng-template #oneUserManual>
                        <div *ngFor="let userManual of model.userManuals.entry">
                          <div class="mb-product-line-data-sheet"
                               [innerHTML]="addDataSheetUserManualLink(userManual.value, 'pdpProductLine.userManual', false) | async | safeHtml"
                               data-cy="mb-product-line-user-manual-sm"
                               data-tagname="User manuals"
                               mbCmsInnerHTML
                          ></div>
                        </div>
                      </ng-template>
                  </span>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showDynamicColumns">
        <div *ngFor="let dynamicColumn of model.productLine"
             class="row no-gutters my-1"
             data-cy="mb-product-line-sm-applications-sm">
          <div class="col-5 my-auto">
            <p class="mb-0 mb-product-line-keys">{{dynamicColumn?.label}}</p>
          </div>
          <div class="col-7 my-auto pl-3 mb-product-line-values product-line-dynamic-column">
            <p class="mb-0"><span [innerHTML]="dynamicColumn?.value | safeHtml"></span></p>
          </div>
        </div>
      </ng-container>

      <div class="row no-gutters my-1"
           data-cy="mb-product-line-quantity-sm">
        <div class="col-5 my-auto">
          <p class="mb-0 mb-product-line-keys">{{'pdpProductLine.quantity' | mbTranslate}}</p>
        </div>
        <div class="col-7 my-auto pl-3">
          <div class="col-5 my-auto px-0">
            <mb-quantity-counter
              [control]="addToCartForm.get('quantity')"
              [max]="maxItemQuantity"
              [min]="1">
            </mb-quantity-counter>
          </div>
        </div>
      </div>

      <div class="row no-gutters my-1">
        <div class="col-5 my-auto text-right"
             data-cy="mb-product-line-price-sm">
          <span *ngIf="!hasPriceOnRequest(); else onRequestMobile">
            <strong [innerHTML]="model.priceData?.formattedValue | safeHtml"></strong>
          </span>
          <ng-template #onRequestMobile>
            <strong>{{'mbcommon.onRequest' | mbTranslate}}</strong>
          </ng-template>
        </div>
        <div [ngClass]="[isWishListShown ? 'mb-product-line-actions' : '', 'col-7 my-auto pl-3']"
             data-cy="mb-product-line-actions-sm">
          <div class=" row no-gutters">
            <div class="col-8">
              <mb-add-to-cart [addToCartForm]="addToCartForm"
                              [clickSource]="dataAnalyticsClickSource"
                              [hasPriceOnRequest]="hasPriceOnRequest()"
                              [product]="model"
                              [productCode]="model.code">
              </mb-add-to-cart>
            </div>
            <div *ngIf="isWishListShown"
                 class="col-4 mb-product-line-wishlist-margin-sm"
                 data-cy="mb-product-line-wishlist-sm">
              <mb-product-line-wishlist [product]="model"></mb-product-line-wishlist>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

